import Vue from 'vue'
import App from './App.vue'
import store from './store/index';

import router from './router'
// 引入初始化样式文件
import './assets/css/reset.css';
Vue.config.productionTip = false
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
Vue.use(Antd);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
